<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Snapshot</h2>
    <button mat-dialog-close matIconButton aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="snapshotForm" (ngSubmit)="submitFormSnapshot()">
    <mat-dialog-content>
      <p>
        By saving this snapshot, you can easily retrieve your selection, zoom and selected layers.
      </p>

      <div class="fields-line-1">
        <mat-form-field class="field-grow">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field class="field-grow">
          <mat-label>Description</mat-label>
          <input matInput formControlName="description" />
        </mat-form-field>
      </div>

      <mat-form-field subscriptSizing="dynamic" class="share-field">
        <mat-label>Share</mat-label>
        <input
          matInput
          formControlName="emails"
          matTooltip=" Write email addresses separated by a semicolon ` ; ` to make this snapshot  accessible to other users. Removing a user from the list will remove their access to the snapshot."
          matTooltipPosition="above"
          placeholder="jane.doe@example.com; john.doe@example.com"
        />
        <mat-hint>Separate the email addresses with a semicolon <b>' ; '</b></mat-hint>
        <ng-container>
          @if (snapshotForm.get('emails')?.invalid) {
            <mat-error>Please enter valid email addresses</mat-error>
          }
        </ng-container>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button matButton matButton="outlined" type="button" class="warn-button" (click)="cancel()">
        Cancel
      </button>
      <button matButton matButton="filled" [disabled]="!snapshotForm.valid" type="submit">
        <ng-container>
          @if (data.id) {
            Update
          } @else {
            Save
          }
        </ng-container>
      </button>
    </mat-dialog-actions>
  </form>
</div>
